exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modulefooter[data-v-1b34bdb4]{margin-bottom:36px;padding-top:27px;border-top:1px solid #d3d4d9;display:-ms-grid;display:grid;-ms-grid-rows:auto;grid-template-rows:auto;row-gap:36px}@media screen and (min-width:978px){.modulefooter[data-v-1b34bdb4]{-ms-grid-columns:300px (1fr)[2];grid-template-columns:300px repeat(2,1fr);column-gap:40px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1b34bdb4","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/parts/modules/modulefooter/ModuleFooter.vue
// module id = 460a789c64615b86ff2e
// module chunks = 0